import React, { useEffect, useState } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { IoWarning } from "react-icons/io5";
import { LuArrowLeft, LuCalendarDays, LuNewspaper } from "react-icons/lu";
import { Link, useParams } from "react-router-dom";
import { serverInstance } from "../../service/axios";
import "./post.scss";

class PostModel {
  id
  title
  description
  dt
  created_at
  location
  fileUrl
}

const Post = ({ data }) => {
  const params = useParams();
  const [post, setPost] = useState(new PostModel());
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(true);
  const postDate = post.dt || post.created_at;
  const formattedDate = postDate
    ? new Date(postDate).toLocaleDateString(data?.title === "Posts" ? "en-US" : "mn-MN", {
      year: "numeric",
      month: "long",
      day: "numeric",
    })
    : "";
  const postImageUrl = post.fileUrl || "";
  const postLabel = data?.title || "Post";
  const aboutLabel = data?.title === "Posts" ? "Full post" : "Дэлгэрэнгүй";
  const dateLabel = data?.title === "Posts" ? "Published" : "Нийтэлсэн";
  const backLabel = data?.title === "Posts" ? "Back to posts" : "Зарлал руу буцах";

  useEffect(() => {
    if (params.id) {
      setLoading(true);
      serverInstance.post("/app/item", { class: "post", id: params.id }, {
        headers: {
          "Content-Type": "application/json",
        }
      })
      .then(res => {
        const item = res.data.item || {};
        setPost({
          ...item,
          fileUrl: item.fileUrl
            ? `https://msid-asset.s3.ap-northeast-2.amazonaws.com/${item.fileUrl}`
            : "",
        })
        setLoading(false);
        setErrorMsg("");
      })
      .catch((err) => {
        setLoading(false);
        setErrorMsg(err?.response?.data?.message || err?.message || String(err));
      })
    }
  }, [params.id]);

  return (
    <div className="post">
      {loading ? (
        <div className="post-loading">
          <AiOutlineLoading3Quarters size={28} className="loading-spinner"/>
        </div>
      ) : (
        <main className="post-shell">
          <Link className="post-back-link" to="/posts">
            <LuArrowLeft aria-hidden="true" />
            <span>{backLabel}</span>
          </Link>

          {errorMsg ? (
            <div className="error-msg">
              <IoWarning/>
              <span>{errorMsg}</span>
            </div>
          ) : null}

          {!errorMsg ? (
            <>
              <section className={"post-hero" + (postImageUrl ? "" : " post-hero-no-image")}>
                {postImageUrl ? (
                  <div className="post-img">
                    <img src={postImageUrl} alt={post.title || ""} />
                  </div>
                ) : null}

                <div className="post-hero-copy">
                  <div className="post-eyebrow">
                    <LuNewspaper aria-hidden="true" />
                    <span>{postLabel}</span>
                  </div>
                  <h1 className="title">{post.title}</h1>

                  {formattedDate ? (
                    <div className="post-meta">
                      <LuCalendarDays aria-hidden="true" />
                      <div>
                        <span className="post-meta-label">{dateLabel}</span>
                        <span className="post-meta-value">{formattedDate}</span>
                      </div>
                    </div>
                  ) : null}
                </div>
              </section>

              <section className="post-story">
                <h2>{aboutLabel}</h2>
                <div className="post-desc">{post.description}</div>
              </section>
            </>
          ) : null}
        </main>
      )}
    </div>
  );
}

export default Post;
